export const SERVICES = {
    FRONT_END: 1,
    SEO: 2,
    ONLINE_COACHING: 3
}

export const MENU_ITEMS = {
    HOME: "home",
    SERVICES: "services",
    TEAM: "team",
    CONTACTS: "contacts"
}